import { useQuery } from "@tanstack/react-query";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { supabase } from "@/integrations/supabase/client";

const ProfessionalAppointments = () => {
  const { data: appointments, isLoading } = useQuery({
    queryKey: ["professional-appointments"],
    queryFn: async () => {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) throw new Error("Not authenticated");

      const { data, error } = await supabase
        .from("professional_appointments")
        .select(`
          *,
          patient:profiles!patient_id(*),
          service:professional_services(*)
        `)
        .eq("professional_id", user.id)
        .order("requested_date", { ascending: true });

      if (error) throw error;
      return data;
    },
  });

  if (isLoading) {
    return <div>Loading...</div>;
  }

  return (
    <div className="space-y-8">
      <div>
        <h1 className="text-3xl font-bold">Rendez-vous</h1>
        <p className="text-muted-foreground mt-2">
          Gérez vos rendez-vous avec vos patients
        </p>
      </div>

      <div className="grid gap-4">
        {appointments?.map((appointment) => (
          <Card key={appointment.id}>
            <CardHeader>
              <CardTitle>
                {appointment.patient?.full_name || "Patient inconnu"}
              </CardTitle>
            </CardHeader>
            <CardContent className="space-y-2">
              <p>
                <span className="font-medium">Date:</span>{" "}
                {new Date(appointment.requested_date).toLocaleString()}
              </p>
              <p>
                <span className="font-medium">Service:</span>{" "}
                {appointment.service?.service_name || "Non spécifié"}
              </p>
              <p>
                <span className="font-medium">Statut:</span>{" "}
                <span className="capitalize">{appointment.status}</span>
              </p>
              {appointment.notes && (
                <p>
                  <span className="font-medium">Notes:</span> {appointment.notes}
                </p>
              )}
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
};

export default ProfessionalAppointments;